import { VenueTagType } from './venue'

export { VenueTagType }

export interface VenueTag {
  key: VenueTagType
  name: string
  value: string
  parent?: {
    key: VenueTagType
    value: string
  }
}

const ambienceTags: VenueTag[] = [
  {
    key: VenueTagType.AMBIENCE,
    name: 'Casual',
    value: 'CASUAL',
  },
  {
    key: VenueTagType.AMBIENCE,
    name: 'Classy',
    value: 'CLASSY',
  },
  {
    key: VenueTagType.AMBIENCE,
    name: 'Upscale',
    value: 'UPSCALE',
  },
  {
    key: VenueTagType.AMBIENCE,
    name: 'Trendy',
    value: 'TRENDY',
  },
  {
    key: VenueTagType.AMBIENCE,
    name: 'Dive Bar',
    value: 'DIVE_BAR',
  },
  {
    key: VenueTagType.AMBIENCE,
    name: 'High Energy',
    value: 'HIGH_ENERGY',
  },
  {
    key: VenueTagType.AMBIENCE,
    name: 'Chill but upbeat',
    value: 'CHILL_BUT_UPBEAT',
  },
  {
    key: VenueTagType.AMBIENCE,
    name: 'Can have a conversation',
    value: 'CAN_HAVE_A_CONVERSATION',
  },
  {
    key: VenueTagType.AMBIENCE,
    name: 'Dance',
    value: 'DANCE',
  },
]

const crowdTags: VenueTag[] = [
  {
    key: VenueTagType.CROWD,
    name: 'Casual',
    value: 'CASUAL',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Upscale',
    value: 'UPSCALE',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Movie Stars',
    value: 'MOVIE_STARS',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Moguls',
    value: 'MOGULS',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Models',
    value: 'MODELS',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Jetsetters',
    value: 'JETSETTERS',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Rich',
    value: 'RICH',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Downtown',
    value: 'DOWNTOWN',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Hipsters',
    value: 'HIPSTERS',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Fashion',
    value: 'FASHION',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Art',
    value: 'ART',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Entertainment',
    value: 'ENTERTAINMENT',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Young Professionals',
    value: 'YOUNG_PROFESSIONALS',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Marketers',
    value: 'MARKETERS',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Financial',
    value: 'FINANCIAL',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Urban',
    value: 'URBAN',
  },
  {
    key: VenueTagType.CROWD,
    name: 'International',
    value: 'INTERNATIONAL',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Trendy',
    value: 'TRENDY',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Students / College',
    value: 'STUDENTS/COLLEGE',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Gay',
    value: 'GAY',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Fashionable',
    value: 'FASHIONABLE',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Corporate',
    value: 'CORPORATE',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Always a mix',
    value: 'ALWAYS_A_MIX',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Appropriately Aged',
    value: 'APPROPRIATELY_AGED',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Rockstars',
    value: 'ROCKSTARS',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Famous Chefs',
    value: 'FAMOUS_CHEFS',
  },
  {
    key: VenueTagType.CROWD,
    name: 'Art Historians',
    value: 'ART_HISTORIANS',
  },
]

const dressCodeOkTags: VenueTag[] = [
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Hats',
    value: 'HATS',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Dress Shoes',
    value: 'DRESS_SHOES',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Dress Shirts',
    value: 'DRESS_SHIRTS',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Shorts',
    value: 'SHORTS',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Sneakers',
    value: 'SNEAKERS',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Flip Flops',
    value: 'FLIP_FLOPS',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Sandals',
    value: 'SANDALS',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Swimsuits',
    value: 'SWIMSUITS',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Sundresses',
    value: 'SUNDRESSES',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Linen Pants or Shorts',
    value: 'LINEN_PANTS_OR_SHORTS',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Floral/Hawaiian Shirts',
    value: 'FLORAL_OR_HAWAIIAN_SHIRTS',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Collared Shirts',
    value: 'COLLARED_SHIRTS',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Short Sleeved Collared Shirts',
    value: 'SHORT_SLEEVED_COLLARED_SHIRTS',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Lifestyle/High Fashion Sneakers',
    value: 'LIFESTYLE_OR_HIGH_FASHION_SNEAKERS',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Button-Down Collared Shirts',
    value: 'BUTTON_DOWN_COLLARED_SHIRTS',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Fashionable Attire',
    value: 'FASHIONABLE_ATTRIE',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Jackets',
    value: 'JACKETS',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'T-Shirts',
    value: 'T-SHIRTS',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Ripped or Baggy Clothes',
    value: 'RIPPED_OR_BAGGY_CLOTHES',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Sports Jerseys',
    value: 'SPORTS_JERSEYS',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Tank Tops',
    value: 'TANK_TOPS',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Khaki Shorts',
    value: 'KHAKI_SHORTS',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Athletic Gear',
    value: 'ATHLETIC_GEAR',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Jeans',
    value: 'JEANS',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Costumes',
    value: 'COSTUMES',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Suits',
    value: 'SUITS',
  },
  {
    key: VenueTagType.DRESS_CODE_OK,
    name: 'Gowns',
    value: 'GOWNS',
  },
]

const dressCodeNotOkTags: VenueTag[] = [
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Jeans',
    value: 'JEANS',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Athletic Sneakers',
    value: 'ATHLETIC_SNEAKERS',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Baseball Hats',
    value: 'BASEBALL_HATS',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Boots',
    value: 'BOOTS',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Excessively Ripped Jeans',
    value: 'EXCESSIVELY_RIPPED_JEANS',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Oversized Chains/Pendants',
    value: 'OVERSIZE_CHAINS_OR_PENDANTS',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Open Toed Shoes',
    value: 'OPEN_TOED_SHOES',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Tennis Shoes',
    value: 'TENNIS_SHOES',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Tank Tops/Cutoff Shirts',
    value: 'TANK_TOPS_OR_CUTOFF_SHIRTS',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Sandals',
    value: 'SANDALS',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Offensive Prints',
    value: 'OFFENSIVE_PRINTS',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Athletic Gear',
    value: 'ATHLETIC_GEAR',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Khaki Shorts',
    value: 'KHAKI_SHORTS',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Hats',
    value: 'HATS',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Dress Shoes',
    value: 'DRESS_SHOES',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Dress Shirts',
    value: 'DRESS_SHIRTS',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Shorts',
    value: 'SHORTS',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Sneakers',
    value: 'SNEAKERS',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Flip Flops',
    value: 'FLIP_FLOPS',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Jackets',
    value: 'JACKETS',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'T-Shirts',
    value: 'T-SHIRTS',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Ripped or Baggy Clothes',
    value: 'RIPPED_OR_BAGGY_CLOTHES',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Sports Jerseys',
    value: 'SPORTS_JERSEYS',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Tank Tops',
    value: 'TANK_TOPS',
  },
  {
    key: VenueTagType.DRESS_CODE_NOT_OK,
    name: 'Work Boots',
    value: 'WORK_BOOTS',
  },
]

const featureTags: VenueTag[] = [
  {
    key: VenueTagType.FEATURES,
    name: 'Dancers',
    value: 'DANCERS',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Televisions',
    value: 'TELEVISIONS',
  },
  {
    key: VenueTagType.FEATURES,
    name: '18+ Friendly',
    value: '18+_FRIENDLY',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Private Events',
    value: 'PRIVATE_EVENTS',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Air Conditioning',
    value: 'AIR_CONDITIONING',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Outdoor Seating',
    value: 'OUTDOOR_SEATING',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'ATM',
    value: 'ATM',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Live Band',
    value: 'LIVE_BAND',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'DJ Booth',
    value: 'DJ_BOOTH',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Parking Lot',
    value: 'PARKING_LOT',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Happy Hours',
    value: 'HAPPY_HOURS',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Stage',
    value: 'STAGE',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Dance Floor',
    value: 'DANCE_FLOOR',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Free Mixers',
    value: 'FREE_MIXERS',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'VIP Restrooms',
    value: 'VIP_RESTROOMS',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Smoking Area',
    value: 'SMOKING_AREA',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Wheelchair Accessible',
    value: 'WHEELCHAIR_ACCESSIBLE',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Elevator in building',
    value: 'ELEVATOR_IN_BUILDING',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Pool',
    value: 'POOL',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Hot Tub',
    value: 'HOT_TUB',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Mixologists',
    value: 'MIXOLOGISTS',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'After Work Specials',
    value: 'AFTER_WORK_SPECIALS',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Free Coat Check',
    value: 'FREE_COAT_CHECK',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Coat Check',
    value: 'COAT_CHECK',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Valet',
    value: 'VALET',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Serves Food',
    value: 'SERVES_FOOD',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Kid Friendly',
    value: 'KID_FRIENDLY',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Dining Area',
    value: 'DINING_AREA',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Kitchen',
    value: 'KITCHEN',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'Garage Parking',
    value: 'GARAGE_PARKING',
  },
  {
    key: VenueTagType.FEATURES,
    name: 'CO2 Machines',
    value: 'CO2_MACHINES',
  },
]

const goodForTags: VenueTag[] = [
  {
    key: VenueTagType.GOOD_FOR,
    name: 'Holiday Parties',
    value: 'HOLIDAY_PARTIES',
  },
  {
    key: VenueTagType.GOOD_FOR,
    name: 'Product Launches',
    value: 'PRODUCT_LAUNCHES',
  },
  {
    key: VenueTagType.GOOD_FOR,
    name: 'Birthday Parties',
    value: 'BIRTHDAY_PARTIES',
  },
  {
    key: VenueTagType.GOOD_FOR,
    name: 'Filmings',
    value: 'FILMINGS',
  },
  {
    key: VenueTagType.GOOD_FOR,
    name: 'Corporate Events',
    value: 'CORPORATE_EVENTS',
  },
  {
    key: VenueTagType.GOOD_FOR,
    name: 'Brunch',
    value: 'BRUNCH',
  },
  {
    key: VenueTagType.GOOD_FOR,
    name: 'Cocktail Reception',
    value: 'COCKTAIL_RECEPTION',
  },
  {
    key: VenueTagType.GOOD_FOR,
    name: 'Wrap Party',
    value: 'WRAP_PARTY',
  },
  {
    key: VenueTagType.GOOD_FOR,
    name: 'Benefits',
    value: 'BENEFITS',
  },
  {
    key: VenueTagType.GOOD_FOR,
    name: 'Fashion Shows',
    value: 'FASHION_SHOWS',
  },
  {
    key: VenueTagType.GOOD_FOR,
    name: 'Bachelorette Parties',
    value: 'BACHELORETTE_PARTIES',
  },
  {
    key: VenueTagType.GOOD_FOR,
    name: 'Bachelor Parties',
    value: 'BACHELOR_PARTIES',
  },
  {
    key: VenueTagType.GOOD_FOR,
    name: 'Late Night',
    value: 'LATE_NIGHTS',
  },
  {
    key: VenueTagType.GOOD_FOR,
    name: 'Rooftop Parties',
    value: 'ROOFTOP_PARTIES',
  },
  {
    key: VenueTagType.GOOD_FOR,
    name: 'Lighting Effects',
    value: 'LIGHTING_EFFECTS',
  },
  {
    key: VenueTagType.GOOD_FOR,
    name: 'Date Night',
    value: 'DATE_NIGHT',
  },
  {
    key: VenueTagType.GOOD_FOR,
    name: 'Girls night out',
    value: 'GIRLS_NIGHT_OUT',
  },
  {
    key: VenueTagType.GOOD_FOR,
    name: 'Guys night out',
    value: 'GUYS_NIGHT_OUT',
  },
  {
    key: VenueTagType.GOOD_FOR,
    name: 'Entertaining Clients',
    value: 'ENTERTAINING_CLIENTS',
  },
  {
    key: VenueTagType.GOOD_FOR,
    name: 'Travelers',
    value: 'TRAVELERS',
  },
]

const musicTags: VenueTag[] = [
  {
    key: VenueTagType.MUSIC,
    name: 'House',
    value: 'HOUSE',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Electronic',
    value: 'ELECTRONIC',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'International',
    value: 'INTERNATIONAL',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Latin',
    value: 'LATIN',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Reggaeton',
    value: 'REGGAETON',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Regional Mexican',
    value: 'REGIONAL_MEXICAN',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Banda',
    value: 'BANDA',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Norteno',
    value: 'NORTENO',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Tropical',
    value: 'TROPICAL',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Brazilian',
    value: 'BRAZILIAN',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Pop',
    value: 'POP',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Disco',
    value: 'DISCO',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Soul',
    value: 'SOUL',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Indie',
    value: 'INDIE',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Top 40',
    value: 'TOP_40',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Reggae',
    value: 'REGGAE',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Live Music',
    value: 'LIVE_MUSIC',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Deep House',
    value: 'DEEP_HOUSE',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Rock',
    value: 'ROCK',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Salsa',
    value: 'SALSA',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Mashups',
    value: 'MASHUPS',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Dubstep',
    value: 'DUBSTEP',
  },
  {
    key: VenueTagType.MUSIC,
    name: "90's",
    value: '90S',
  },
  {
    key: VenueTagType.MUSIC,
    name: "80's",
    value: '80S',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Drum and Bass',
    value: 'DRUM_AND_BASS',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Electronica',
    value: 'ELECTRONICA',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'EDM',
    value: 'EDM',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Techno',
    value: 'TECHNO',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Hip Hop',
    value: 'HIP_HOP',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Trance',
    value: 'TRANCE',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Garage',
    value: 'GARAGE',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Grime',
    value: 'GRIME',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Tech House',
    value: 'TECH_HOUSE',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Tropical House',
    value: 'TROPICAL_HOUSE',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Nu-Disco',
    value: 'NU_DISCO',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Future Bass',
    value: 'FUTURE_BASS',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'UK Garage',
    value: 'UK_GARAGE',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Hardstyle',
    value: 'HARDSTYLE',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Juke',
    value: 'JUKE',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Breakbeat',
    value: 'BREAKBEAT',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Downtempo',
    value: 'DOWNTEMPO',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Rave',
    value: 'RAVE',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Acid House',
    value: 'ACID_HOUSE',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Open Format',
    value: 'OPEN_FORMAT',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Jazz',
    value: 'JAZZ',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Rap',
    value: 'RAP',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'R&B',
    value: 'R_AND_B',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Dance Music',
    value: 'DANCE_MUSIC',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Electro House',
    value: 'ELECTRO_HOUSE',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Good',
    value: 'GOOD',
  },
  {
    key: VenueTagType.MUSIC,
    name: 'Country',
    value: 'COUNTRY',
  },
]

const noiseLevelTags: VenueTag[] = [
  {
    key: VenueTagType.NOISE_LEVELS,
    name: 'Quiet',
    value: 'QUIET',
  },
  {
    key: VenueTagType.NOISE_LEVELS,
    name: 'Moderate',
    value: 'MODERATE',
  },
  {
    key: VenueTagType.NOISE_LEVELS,
    name: 'Loud',
    value: 'LOUD',
  },
  {
    key: VenueTagType.NOISE_LEVELS,
    name: 'Can have a conversation',
    value: 'CAN_HAVE_A_CONVERSATION',
  },
]

const busyNightsTags: VenueTag[] = [
  {
    key: VenueTagType.BUSY_NIGHTS,
    name: '0',
    value: '0',
  },
  {
    key: VenueTagType.BUSY_NIGHTS,
    name: '1',
    value: '1',
  },
  {
    key: VenueTagType.BUSY_NIGHTS,
    name: '2',
    value: '2',
  },
  {
    key: VenueTagType.BUSY_NIGHTS,
    name: '3',
    value: '3',
  },
  {
    key: VenueTagType.BUSY_NIGHTS,
    name: '4',
    value: '4',
  },
  {
    key: VenueTagType.BUSY_NIGHTS,
    name: '5',
    value: '5',
  },
  {
    key: VenueTagType.BUSY_NIGHTS,
    name: '6',
    value: '6',
  },
]

// Namespace all tags to ensure they are unique
const namespaceTags = (tags: VenueTag[]): VenueTag[] => {
  return tags.map((tag) => {
    const namespacedTag = { ...tag }
    namespacedTag.value = `${tag.key}_${tag.value}`
    if (tag.parent) {
      namespacedTag.value = `${tag.parent.key}_${tag.parent.value}_${namespacedTag.value}`
    }
    return namespacedTag
  })
}

const allTags = [
  ...ambienceTags,
  ...crowdTags,
  ...dressCodeOkTags,
  ...dressCodeNotOkTags,
  ...featureTags,
  ...goodForTags,
  ...musicTags,
  ...noiseLevelTags,
  ...busyNightsTags,
]

export const VENUE_TAGS = namespaceTags(allTags)
